<template>
  <teleport to="body">
    <transition name="menu">
      <div v-if="show" class="overlay">
        <header>
          <img
            width="100"
            src="data:image/svg+xml;base64,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"
          />
          <div class="controls">
            <button @click="tryClose">
              <img
                height="25"
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAyNyAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2IDFMMSAyNiIgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMSAxTDI2IDI2IiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
              />
            </button>
          </div>
        </header>
        <div class="flex justify-center h-full">
          <div class="flex flex-col justify-center text-center">
            <router-link to="/about">About</router-link>
            <router-link to="/location">Location</router-link>
            <router-link to="/finder">Finder</router-link>
            <router-link to="/gallery">Gallery</router-link>
            <router-link to="/contact">Contact</router-link>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close"],
  methods: {
    tryClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background-color: #2d2926;
  overflow: hidden;
}

/* The navigation links inside the overlay */
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #fff;
  display: block; /* Display block instead of inline */
  transition: 0.3s; /* Transition effects on hover (color) */
  -webkit-text-stroke: 1px;
  -webkit-text-fill-color: rgba(0, 0, 0, 0);
  font-family: "Circular Black", sans-serif;
}

/* When you mouse over the navigation links, change their color */
.overlay a:hover,
.overlay a:focus {
  -webkit-text-stroke: unset;
  -webkit-text-fill-color: #FFFF;
}

header {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: left;
  align-items: flex-start;
  padding: 1.5rem;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 90;
}

.controls {
  width: 100%;
  text-align: right;
}

img {
  vertical-align: middle;
  border-style: none;
  height: 25px;
  max-width: unset;
}

button {
  background-color: transparent;
  border: 1px solid transparent;
  text-align: center;
  vertical-align: middle;
  padding: 0;
  margin: 0;
}

.menu-enter-from,
.menu-leave-to {
  opacity: 0;
  /* transform: scale(0.8); */
}

.menu-enter-active {
  transition: all 0.3s ease-out;
}

.menu-leave-active {
  transition: all 0.3s ease-in;
}

.menu-enter-to,
.menu-leave-from {
  opacity: 1;
  /* transform: scale(1); */
}
</style>
